<template>
  <v-dialog v-model="dialog" max-width="400" class="rounded-0">
    <template v-slot:activator="{ on }">
      <v-btn
        :ripple="false"
        class="notification-btn"
        icon
        :color="$vuetify.theme.dark ? 'greenMain' : '#171717'"
        @click="showLogoutDialog"
        v-on="on"
      >
        <v-icon>mdi-power</v-icon>
      </v-btn>
    </template>
    <v-card
      rounded="0"
      width="400"
      class="auth-modal-card"
      :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'"
    >
      <v-card-title class="px-0 pt-0"> Log Out ? </v-card-title>
      <v-card-text class="px-0"
        >Do You want to log out from your account?</v-card-text
      >
      <v-card-actions class="px-0 pb-0">
        <v-btn
          class="elevation-0"
          :color="$vuetify.theme.dark ? '#FF567F' : '#FF567F'"
          @click.prevent="logoutAndHideDialog"
        >
          Log Out
        </v-btn>
        <v-btn
          class="elevation-0"
          :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'"
          outlined
          @click.prevent="hideLogoutDialog"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  AUTHENTICATION__ACTIONS,
  LOGOUT__DIALOG__ACTIONS,
} from "../../store/action-types";

export default {
  computed: {
    ...mapState("logoutDialog", ["dialog"]),
  },
  methods: {
    ...mapActions("logoutDialog", {
      showLogoutDialog: LOGOUT__DIALOG__ACTIONS.SHOWDIALOG,
      hideLogoutDialog: LOGOUT__DIALOG__ACTIONS.HIDEDIALOG,
    }),
    ...mapActions("authentication", {
      LOGOUT: AUTHENTICATION__ACTIONS.LOGOUT,
    }),

    logoutAndHideDialog() {
      this.hideLogoutDialog();
      this.LOGOUT();
    },
  },
};
</script>
